<template>
  <div class="widget w-i-frame-widget">
    <c-widget-header>
      {{ label }}
      <slot name="buttons" slot="buttons" />
    </c-widget-header>

    <c-widget-control-bar>
      <v-form-group label="URL:" label-cols="auto">
        <v-form-input :value="url" @input="changeUrl" />
      </v-form-group>
    </c-widget-control-bar>

    <div class="widget-body">
      <iframe :src="url" />
    </div>
  </div>
</template>

<script>
import CWidgetControlBar from '@custom/widgetContainer/CWidgetControlBar';
import CWidgetHeader from '@custom/widgetContainer/CWidgetHeader';
import CWidgetHeaderButton from '@custom/widgetContainer/CWidgetHeaderButton';

export default {
  name: 'w-i-frame-widget',
  components: { CWidgetControlBar, CWidgetHeader, CWidgetHeaderButton },
  props: {
    label: {
      type: String,
      required: true
    }
    // add own props
  },
  data() {
    return {
      url: 'about:blank'
      // add own data
    };
  },
  methods: {
    changeUrl(e) {
      this.url = e.startsWith('http') ? e : 'https://' + e;
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/widgets/iframe-widget';
</style>
